import React, { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  it: {
    home: 'Home', feed: 'Feed', leaderboard: 'Classifica', chat: 'Chat', profile: 'Profilo',
    settings: 'Impostazioni', login: 'Accedi', register: 'Registrati', logout: 'Esci',
    heroTitle: 'Trasforma una vita oggi', heroSubtitle: 'Connetti chi può aiutare con chi ha bisogno. Ogni donazione crea un impatto reale.',
    getStarted: 'Inizia ora', howItWorks: 'Come funziona',
    email: 'Email', password: 'Password', name: 'Nome', confirmPassword: 'Conferma Password',
    loginWithGoogle: 'Accedi con Google', noAccount: 'Non hai un account?', haveAccount: 'Hai già un account?',
    iAmDonor: 'Voglio donare', iAmRecipient: 'Ho bisogno di aiuto',
    createPost: 'Crea richiesta', needHelp: 'Ho bisogno di aiuto', shareYourStory: 'Racconta la tua storia',
    allRequests: 'Tutte le Richieste', scrollDiscover: 'Scorri e scopri chi ha bisogno del tuo aiuto',
    title: 'Titolo', description: 'Descrizione', amountNeeded: 'Importo necessario', category: 'Categoria',
    uploadImages: 'Carica immagini', uploadVideo: 'Carica video', submit: 'Pubblica',
    donate: 'Dona', donateNow: 'Dona ora', share: 'Condividi', raised: 'Raccolti', goal: 'Obiettivo',
    donors: 'Donatori', verified: 'Verificato',
    medical: 'Spese Mediche', education: 'Istruzione', housing: 'Casa', food: 'Cibo',
    emergency: 'Emergenza', business: 'Attività', other: 'Altro',
    selectAmount: 'Seleziona importo', customAmount: 'Importo personalizzato',
    paymentMethod: 'Metodo di pagamento', message: 'Messaggio (opzionale)',
    anonymous: 'Donazione anonima', completeDonation: 'Completa donazione',
    thankYou: 'Grazie per la tua generosità!', donationSuccess: 'Donazione completata con successo',
    topDonors: 'I migliori donatori', totalDonated: 'Totale donato', donations: 'Donazioni', rank: 'Posizione',
    conversations: 'Conversazioni', typeMessage: 'Scrivi un messaggio...', send: 'Invia',
    noMessages: 'Nessun messaggio', startConversation: 'Inizia una conversazione',
    editProfile: 'Modifica profilo', myPosts: 'Le mie richieste', myDonations: 'Le mie donazioni',
    totalReceived: 'Totale ricevuto', memberSince: 'Membro dal',
    notifications: 'Notifiche', markAllRead: 'Segna tutte come lette', noNotifications: 'Nessuna notifica',
    newDonation: 'Nuova donazione!',
    loading: 'Caricamento...', error: 'Errore', success: 'Successo', cancel: 'Annulla', save: 'Salva',
    delete: 'Elimina', edit: 'Modifica', view: 'Visualizza', all: 'Tutti', active: 'Attivi',
    completed: 'Completati', currency: 'Valuta', amount: 'Importo', date: 'Data', status: 'Stato',
    search: 'Cerca', filter: 'Filtra', noResults: 'Nessun risultato', seeAll: 'Vedi tutti', back: 'Indietro',
    corporateFund: 'Fondo Aziendale', advertise: 'Pubblicità',
    age: 'Età', gender: 'Sesso', city: 'Città di residenza', male: 'Maschio', female: 'Femmina', nonBinary: 'Non binario', preferNotSay: 'Preferisco non dire',
    fundUpdates: 'Aggiornamenti sull\'utilizzo dei fondi', postUpdate: 'Pubblica aggiornamento',
    updatePlaceholder: 'Spiega come hai utilizzato i fondi ricevuti...',
  },
  en: {
    home: 'Home', feed: 'Feed', leaderboard: 'Leaderboard', chat: 'Chat', profile: 'Profile',
    settings: 'Settings', login: 'Login', register: 'Register', logout: 'Logout',
    heroTitle: 'Transform a life today', heroSubtitle: 'Connect those who can help with those in need. Every donation creates real impact.',
    getStarted: 'Get Started', howItWorks: 'How it works',
    email: 'Email', password: 'Password', name: 'Name', confirmPassword: 'Confirm Password',
    loginWithGoogle: 'Login with Google', noAccount: "Don't have an account?", haveAccount: 'Already have an account?',
    iAmDonor: 'I want to donate', iAmRecipient: 'I need help',
    createPost: 'Create request', needHelp: 'I need help', shareYourStory: 'Share your story',
    allRequests: 'All Requests', scrollDiscover: 'Scroll and discover who needs your help',
    title: 'Title', description: 'Description', amountNeeded: 'Amount needed', category: 'Category',
    uploadImages: 'Upload images', uploadVideo: 'Upload video', submit: 'Submit',
    donate: 'Donate', donateNow: 'Donate Now', share: 'Share', raised: 'Raised', goal: 'Goal',
    donors: 'Donors', verified: 'Verified',
    medical: 'Medical Expenses', education: 'Education', housing: 'Housing', food: 'Food',
    emergency: 'Emergency', business: 'Business', other: 'Other',
    selectAmount: 'Select amount', customAmount: 'Custom amount',
    paymentMethod: 'Payment method', message: 'Message (optional)',
    anonymous: 'Anonymous donation', completeDonation: 'Complete donation',
    thankYou: 'Thank you for your generosity!', donationSuccess: 'Donation completed successfully',
    topDonors: 'Top donors', totalDonated: 'Total donated', donations: 'Donations', rank: 'Rank',
    conversations: 'Conversations', typeMessage: 'Type a message...', send: 'Send',
    noMessages: 'No messages', startConversation: 'Start a conversation',
    editProfile: 'Edit profile', myPosts: 'My requests', myDonations: 'My donations',
    totalReceived: 'Total received', memberSince: 'Member since',
    notifications: 'Notifications', markAllRead: 'Mark all as read', noNotifications: 'No notifications',
    newDonation: 'New donation!',
    loading: 'Loading...', error: 'Error', success: 'Success', cancel: 'Cancel', save: 'Save',
    delete: 'Delete', edit: 'Edit', view: 'View', all: 'All', active: 'Active',
    completed: 'Completed', currency: 'Currency', amount: 'Amount', date: 'Date', status: 'Status',
    search: 'Search', filter: 'Filter', noResults: 'No results', seeAll: 'See all', back: 'Back',
    corporateFund: 'Corporate Fund', advertise: 'Advertise',
    age: 'Age', gender: 'Gender', city: 'City of residence', male: 'Male', female: 'Female', nonBinary: 'Non-binary', preferNotSay: 'Prefer not to say',
    fundUpdates: 'Fund usage updates', postUpdate: 'Post update',
    updatePlaceholder: 'Explain how you used the funds received...',
  },
  fr: {
    home: 'Accueil', feed: 'Fil', leaderboard: 'Classement', chat: 'Discussion', profile: 'Profil',
    settings: 'Paramètres', login: 'Connexion', register: "S'inscrire", logout: 'Déconnexion',
    heroTitle: "Transformez une vie aujourd'hui", heroSubtitle: 'Connectez ceux qui peuvent aider avec ceux qui en ont besoin. Chaque don crée un impact réel.',
    getStarted: 'Commencer', howItWorks: 'Comment ça marche',
    email: 'Email', password: 'Mot de passe', name: 'Nom', confirmPassword: 'Confirmer le mot de passe',
    loginWithGoogle: 'Se connecter avec Google', noAccount: "Pas de compte ?", haveAccount: 'Déjà un compte ?',
    iAmDonor: 'Je veux donner', iAmRecipient: "J'ai besoin d'aide",
    createPost: 'Créer une demande', needHelp: "J'ai besoin d'aide", shareYourStory: 'Racontez votre histoire',
    allRequests: 'Toutes les demandes', scrollDiscover: "Découvrez qui a besoin de votre aide",
    title: 'Titre', description: 'Description', amountNeeded: 'Montant nécessaire', category: 'Catégorie',
    uploadImages: 'Télécharger des images', uploadVideo: 'Télécharger une vidéo', submit: 'Publier',
    donate: 'Donner', donateNow: 'Donner maintenant', share: 'Partager', raised: 'Collecté', goal: 'Objectif',
    donors: 'Donateurs', verified: 'Vérifié',
    medical: 'Frais médicaux', education: 'Éducation', housing: 'Logement', food: 'Alimentation',
    emergency: 'Urgence', business: 'Entreprise', other: 'Autre',
    selectAmount: 'Sélectionner le montant', customAmount: 'Montant personnalisé',
    paymentMethod: 'Mode de paiement', message: 'Message (optionnel)',
    anonymous: 'Don anonyme', completeDonation: 'Compléter le don',
    thankYou: 'Merci pour votre générosité !', donationSuccess: 'Don effectué avec succès',
    topDonors: 'Meilleurs donateurs', totalDonated: 'Total donné', donations: 'Dons', rank: 'Position',
    conversations: 'Conversations', typeMessage: 'Tapez un message...', send: 'Envoyer',
    noMessages: 'Aucun message', startConversation: 'Démarrer une conversation',
    editProfile: 'Modifier le profil', myPosts: 'Mes demandes', myDonations: 'Mes dons',
    totalReceived: 'Total reçu', memberSince: 'Membre depuis',
    notifications: 'Notifications', markAllRead: 'Tout marquer comme lu', noNotifications: 'Aucune notification',
    newDonation: 'Nouveau don !',
    loading: 'Chargement...', error: 'Erreur', success: 'Succès', cancel: 'Annuler', save: 'Enregistrer',
    delete: 'Supprimer', edit: 'Modifier', view: 'Voir', all: 'Tous', active: 'Actifs',
    completed: 'Terminés', currency: 'Devise', amount: 'Montant', date: 'Date', status: 'Statut',
    search: 'Rechercher', filter: 'Filtrer', noResults: 'Aucun résultat', seeAll: 'Voir tout', back: 'Retour',
    corporateFund: "Fonds d'entreprise", advertise: 'Publicité',
    age: 'Âge', gender: 'Sexe', city: 'Ville de résidence', male: 'Homme', female: 'Femme', nonBinary: 'Non-binaire', preferNotSay: 'Préfère ne pas dire',
    fundUpdates: "Mises à jour de l'utilisation des fonds", postUpdate: 'Publier une mise à jour',
    updatePlaceholder: 'Expliquez comment vous avez utilisé les fonds reçus...',
  },
  de: {
    home: 'Startseite', feed: 'Feed', leaderboard: 'Rangliste', chat: 'Chat', profile: 'Profil',
    settings: 'Einstellungen', login: 'Anmelden', register: 'Registrieren', logout: 'Abmelden',
    heroTitle: 'Verändere heute ein Leben', heroSubtitle: 'Verbinde diejenigen, die helfen können, mit denen, die Hilfe brauchen. Jede Spende macht einen echten Unterschied.',
    getStarted: 'Jetzt starten', howItWorks: 'So funktioniert es',
    email: 'E-Mail', password: 'Passwort', name: 'Name', confirmPassword: 'Passwort bestätigen',
    loginWithGoogle: 'Mit Google anmelden', noAccount: 'Noch kein Konto?', haveAccount: 'Bereits ein Konto?',
    iAmDonor: 'Ich möchte spenden', iAmRecipient: 'Ich brauche Hilfe',
    createPost: 'Anfrage erstellen', needHelp: 'Ich brauche Hilfe', shareYourStory: 'Erzähle deine Geschichte',
    allRequests: 'Alle Anfragen', scrollDiscover: 'Scrolle und entdecke, wer deine Hilfe braucht',
    title: 'Titel', description: 'Beschreibung', amountNeeded: 'Benötigter Betrag', category: 'Kategorie',
    uploadImages: 'Bilder hochladen', uploadVideo: 'Video hochladen', submit: 'Veröffentlichen',
    donate: 'Spenden', donateNow: 'Jetzt spenden', share: 'Teilen', raised: 'Gesammelt', goal: 'Ziel',
    donors: 'Spender', verified: 'Verifiziert',
    medical: 'Medizinische Kosten', education: 'Bildung', housing: 'Wohnung', food: 'Essen',
    emergency: 'Notfall', business: 'Geschäft', other: 'Sonstiges',
    selectAmount: 'Betrag wählen', customAmount: 'Eigener Betrag',
    paymentMethod: 'Zahlungsmethode', message: 'Nachricht (optional)',
    anonymous: 'Anonyme Spende', completeDonation: 'Spende abschließen',
    thankYou: 'Vielen Dank für deine Großzügigkeit!', donationSuccess: 'Spende erfolgreich abgeschlossen',
    topDonors: 'Top-Spender', totalDonated: 'Gesamt gespendet', donations: 'Spenden', rank: 'Rang',
    conversations: 'Gespräche', typeMessage: 'Nachricht eingeben...', send: 'Senden',
    noMessages: 'Keine Nachrichten', startConversation: 'Gespräch starten',
    editProfile: 'Profil bearbeiten', myPosts: 'Meine Anfragen', myDonations: 'Meine Spenden',
    totalReceived: 'Gesamt erhalten', memberSince: 'Mitglied seit',
    notifications: 'Benachrichtigungen', markAllRead: 'Alle als gelesen markieren', noNotifications: 'Keine Benachrichtigungen',
    newDonation: 'Neue Spende!',
    loading: 'Laden...', error: 'Fehler', success: 'Erfolg', cancel: 'Abbrechen', save: 'Speichern',
    delete: 'Löschen', edit: 'Bearbeiten', view: 'Ansehen', all: 'Alle', active: 'Aktiv',
    completed: 'Abgeschlossen', currency: 'Währung', amount: 'Betrag', date: 'Datum', status: 'Status',
    search: 'Suchen', filter: 'Filtern', noResults: 'Keine Ergebnisse', seeAll: 'Alle anzeigen', back: 'Zurück',
    corporateFund: 'Unternehmensfonds', advertise: 'Werbung',
    age: 'Alter', gender: 'Geschlecht', city: 'Wohnort', male: 'Männlich', female: 'Weiblich', nonBinary: 'Nicht-binär', preferNotSay: 'Keine Angabe',
    fundUpdates: 'Aktualisierungen zur Verwendung der Mittel', postUpdate: 'Update veröffentlichen',
    updatePlaceholder: 'Erklären Sie, wie Sie die erhaltenen Mittel verwendet haben...',
  },
  es: {
    home: 'Inicio', feed: 'Feed', leaderboard: 'Clasificación', chat: 'Chat', profile: 'Perfil',
    settings: 'Configuración', login: 'Iniciar sesión', register: 'Registrarse', logout: 'Cerrar sesión',
    heroTitle: 'Transforma una vida hoy', heroSubtitle: 'Conecta a quienes pueden ayudar con quienes lo necesitan. Cada donación crea un impacto real.',
    getStarted: 'Comenzar', howItWorks: 'Cómo funciona',
    email: 'Email', password: 'Contraseña', name: 'Nombre', confirmPassword: 'Confirmar contraseña',
    loginWithGoogle: 'Iniciar con Google', noAccount: '¿No tienes cuenta?', haveAccount: '¿Ya tienes cuenta?',
    iAmDonor: 'Quiero donar', iAmRecipient: 'Necesito ayuda',
    createPost: 'Crear solicitud', needHelp: 'Necesito ayuda', shareYourStory: 'Cuenta tu historia',
    allRequests: 'Todas las solicitudes', scrollDiscover: 'Descubre quién necesita tu ayuda',
    title: 'Título', description: 'Descripción', amountNeeded: 'Monto necesario', category: 'Categoría',
    uploadImages: 'Subir imágenes', uploadVideo: 'Subir video', submit: 'Publicar',
    donate: 'Donar', donateNow: 'Donar ahora', share: 'Compartir', raised: 'Recaudado', goal: 'Meta',
    donors: 'Donantes', verified: 'Verificado',
    medical: 'Gastos médicos', education: 'Educación', housing: 'Vivienda', food: 'Alimentación',
    emergency: 'Emergencia', business: 'Negocio', other: 'Otro',
    selectAmount: 'Seleccionar monto', customAmount: 'Monto personalizado',
    paymentMethod: 'Método de pago', message: 'Mensaje (opcional)',
    anonymous: 'Donación anónima', completeDonation: 'Completar donación',
    thankYou: '¡Gracias por tu generosidad!', donationSuccess: 'Donación completada con éxito',
    topDonors: 'Mejores donantes', totalDonated: 'Total donado', donations: 'Donaciones', rank: 'Posición',
    conversations: 'Conversaciones', typeMessage: 'Escribe un mensaje...', send: 'Enviar',
    noMessages: 'Sin mensajes', startConversation: 'Iniciar conversación',
    editProfile: 'Editar perfil', myPosts: 'Mis solicitudes', myDonations: 'Mis donaciones',
    totalReceived: 'Total recibido', memberSince: 'Miembro desde',
    notifications: 'Notificaciones', markAllRead: 'Marcar todo como leído', noNotifications: 'Sin notificaciones',
    newDonation: '¡Nueva donación!',
    loading: 'Cargando...', error: 'Error', success: 'Éxito', cancel: 'Cancelar', save: 'Guardar',
    delete: 'Eliminar', edit: 'Editar', view: 'Ver', all: 'Todos', active: 'Activos',
    completed: 'Completados', currency: 'Moneda', amount: 'Monto', date: 'Fecha', status: 'Estado',
    search: 'Buscar', filter: 'Filtrar', noResults: 'Sin resultados', seeAll: 'Ver todos', back: 'Atrás',
    corporateFund: 'Fondo empresarial', advertise: 'Publicidad',
    age: 'Edad', gender: 'Sexo', city: 'Ciudad de residencia', male: 'Masculino', female: 'Femenino', nonBinary: 'No binario', preferNotSay: 'Prefiero no decir',
    fundUpdates: 'Actualizaciones del uso de fondos', postUpdate: 'Publicar actualización',
    updatePlaceholder: 'Explica cómo usaste los fondos recibidos...',
  },
  zh: {
    home: '首页', feed: '动态', leaderboard: '排行榜', chat: '聊天', profile: '个人资料',
    settings: '设置', login: '登录', register: '注册', logout: '退出',
    heroTitle: '今天改变一个人的生活', heroSubtitle: '连接能够帮助的人和需要帮助的人。每一笔捐款都能产生真正的影响。',
    getStarted: '开始', howItWorks: '如何运作',
    email: '邮箱', password: '密码', name: '姓名', confirmPassword: '确认密码',
    loginWithGoogle: '使用Google登录', noAccount: '没有账户？', haveAccount: '已有账户？',
    iAmDonor: '我想捐赠', iAmRecipient: '我需要帮助',
    createPost: '创建请求', needHelp: '我需要帮助', shareYourStory: '分享你的故事',
    allRequests: '所有请求', scrollDiscover: '滚动发现谁需要你的帮助',
    title: '标题', description: '描述', amountNeeded: '所需金额', category: '类别',
    uploadImages: '上传图片', uploadVideo: '上传视频', submit: '发布',
    donate: '捐赠', donateNow: '立即捐赠', share: '分享', raised: '已筹集', goal: '目标',
    donors: '捐赠者', verified: '已验证',
    medical: '医疗费用', education: '教育', housing: '住房', food: '食物',
    emergency: '紧急', business: '事业', other: '其他',
    selectAmount: '选择金额', customAmount: '自定义金额',
    paymentMethod: '支付方式', message: '留言（可选）',
    anonymous: '匿名捐赠', completeDonation: '完成捐赠',
    thankYou: '感谢你的慷慨！', donationSuccess: '捐赠成功',
    topDonors: '顶级捐赠者', totalDonated: '总捐赠额', donations: '捐赠', rank: '排名',
    conversations: '对话', typeMessage: '输入消息...', send: '发送',
    noMessages: '暂无消息', startConversation: '开始对话',
    editProfile: '编辑资料', myPosts: '我的请求', myDonations: '我的捐赠',
    totalReceived: '总收到', memberSince: '加入时间',
    notifications: '通知', markAllRead: '全部标为已读', noNotifications: '暂无通知',
    newDonation: '新捐赠！',
    loading: '加载中...', error: '错误', success: '成功', cancel: '取消', save: '保存',
    delete: '删除', edit: '编辑', view: '查看', all: '全部', active: '进行中',
    completed: '已完成', currency: '货币', amount: '金额', date: '日期', status: '状态',
    search: '搜索', filter: '筛选', noResults: '没有结果', seeAll: '查看全部', back: '返回',
    corporateFund: '企业基金', advertise: '广告',
    age: '年龄', gender: '性别', city: '居住城市', male: '男', female: '女', nonBinary: '非二元', preferNotSay: '不愿透露',
    fundUpdates: '资金使用更新', postUpdate: '发布更新',
    updatePlaceholder: '说明您如何使用收到的资金...',
  }
};

const languageLabels = {
  it: { flag: '🇮🇹', label: 'Italiano', short: 'IT' },
  en: { flag: '🇬🇧', label: 'English', short: 'EN' },
  fr: { flag: '🇫🇷', label: 'Français', short: 'FR' },
  de: { flag: '🇩🇪', label: 'Deutsch', short: 'DE' },
  es: { flag: '🇪🇸', label: 'Español', short: 'ES' },
  zh: { flag: '🇨🇳', label: '中文', short: 'ZH' }
};

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => localStorage.getItem('language') || 'it');

  const t = useCallback((key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  }, [language]);

  const changeLanguage = useCallback((lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  }, []);

  return (
    <LanguageContext.Provider value={{ language, t, changeLanguage, languageLabels, translations }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
